import type { RefObject } from 'react';
import ImageUrlUploadField from '@/components/ui/ImageUrlUploadField';
import { MediaSource } from '@/types/media';

export default function RichMessageImage({ value, onChange, onUploadingChange, inputRef }: {
  inputRef?: RefObject<HTMLInputElement | null>;
  value: string;
  onChange: (url: string) => void;
  onUploadingChange: (uploading: boolean) => void;
}) {
  return <ImageUrlUploadField inputRef={inputRef} compact source={MediaSource.AD_IMAGE} value={value}
    onChange={onChange} onUploadingChange={onUploadingChange} maxGifSizeBytes={5 * 1024 * 1024} />;
}
